
<template>
  <div>
    <van-nav-bar
      title="我的违约"
      fixed
      placeholder
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
    <div class="mt-1">
      <div>
        <div class="mt-1"></div>
        <div class="mt-2 max-h-64 mb-2 overflow-y-auto overscroll-contain" v-if="myViolations">
          <van-cell
            v-for="violation in myViolations"
            :key="violation.id"
            :title="violation.spaceInfo"
            center
            size="large"
            :label="`违约时间：` + violation.renegeTime"
          >
            <template #default>
              <van-tag plain type="danger"
                ><span class="whitespace-nowrap">{{
                  violation.renegeCategoryInfo
                }}</span></van-tag
              >
            </template>
          </van-cell>
        </div>
        <van-empty description="暂无违约" v-else/>
      </div>
    </div>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getMyViolations } from "@/service/home";
import Cookies from "js-cookie";
export default {
  name: "myViolations",
  components: {},
  setup() {
    const user = JSON.parse(Cookies.get("user"));
    const router = useRouter();
    const state = reactive({
      myViolations: [],
      myRoomViolations: [],
    });

    onMounted(() => {
      loadViolations();
    });
    const goBack = () => router.go(-1);
    const loadViolations = async () => {
      const { data:{list }} = await getMyViolations({
        access_token: user.access_token,
        userid: user.userid,
        operateChannel:3
      });
      state.myViolations = list;
    };

    return {
      goBack,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" >
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
.van-cell__title {
  flex: 1 1 auto;
}
.van-cell__value {
  flex: 1 1 auto;
}
</style>
